import React from 'react';
import {Button} from '@mui/material';
import {AirplayOutlined, CheckCircleOutlined, ImportContactsTwoTone, PlayCircleOutlined} from '@mui/icons-material';
import './taskTypeModal.scss';
import closeIcon from '../images/close.svg';
import { ReactComponent as PaperclipIcon} from '../../assets/icons/paperclip.svg';
import { ReactComponent as TextIcon } from '../../assets/icons/text.svg';

function TaskTypeSelectModal({close} : any) {
    const submitHandler = (type: string) => {
        close(type);
    }

    return (
        <div className="modal-content">
            <button onClick={() => close()} className="close-btn">
                <img src={closeIcon} alt="close-modal"/>
            </button>
            <div className="auth-modal-content">
                <h3>Выберите вид задания</h3>
                <div className="types">
                    <Button variant="outlined" onClick={() => submitHandler('1')}>
                        <PlayCircleOutlined/>
                        Видео
                    </Button>
                    <Button variant="outlined" onClick={() => submitHandler('2')}>
                        <ImportContactsTwoTone/>
                        Глоссарий
                    </Button>
                    <Button variant="outlined" onClick={() => submitHandler('3')}>
                        <PaperclipIcon/>
                        Презентация
                    </Button>
                    <Button variant="outlined" onClick={() => submitHandler('4')}>
                        <TextIcon/>
                        Тест
                    </Button>
                    <Button variant="outlined" onClick={() => submitHandler('5')}>
                        <CheckCircleOutlined/>
                        Задания
                    </Button>
                    <Button variant="outlined" onClick={() => submitHandler('6')}>
                        <AirplayOutlined/>
                        Вебинар
                    </Button>
                </div>
            </div>
        </div>);
}

export default TaskTypeSelectModal;
